import { cloneDeep } from 'lodash';

const completeCall = (state, payload) => {
  const newState = cloneDeep(state);
  delete newState.calls[payload.pointId]
  return newState;
};

export { completeCall };
